var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIpad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ipad",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.566,
    height: 75.566,
    viewBox: "0 0 75.566 75.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9052",
    "data-name": "Path 9052",
    d: "M60.217,36.2a1.181,1.181,0,0,0-1.181,1.181V69.663A3.546,3.546,0,0,1,55.494,73.2H5.9a3.546,3.546,0,0,1-3.542-3.542V5.9A3.546,3.546,0,0,1,5.9,2.361h49.59A3.546,3.546,0,0,1,59.036,5.9V14.57a1.181,1.181,0,1,0,2.361,0V5.9a5.911,5.911,0,0,0-5.9-5.9H5.9A5.911,5.911,0,0,0,0,5.9V69.663a5.911,5.911,0,0,0,5.9,5.9h49.59a5.911,5.911,0,0,0,5.9-5.9V37.382A1.181,1.181,0,0,0,60.217,36.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9053",
    "data-name": "Path 9053",
    d: "M54.771,19.389a1.181,1.181,0,0,0,1.181-1.181V7.181A1.181,1.181,0,0,0,54.771,6H5.181A1.181,1.181,0,0,0,4,7.181V61.494a1.181,1.181,0,0,0,1.181,1.181h49.59a1.181,1.181,0,0,0,1.181-1.181V41.009a1.181,1.181,0,0,0-2.361,0v19.3H6.361V8.361H53.59v9.847A1.181,1.181,0,0,0,54.771,19.389Z",
    transform: "translate(0.723 1.084)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9054",
    "data-name": "Path 9054",
    d: "M28.9,5.361A1.181,1.181,0,0,0,28.9,3H24.181a1.181,1.181,0,0,0,0,2.361Z",
    transform: "translate(4.157 0.542)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9055",
    "data-name": "Path 9055",
    d: "M23,58.542A3.542,3.542,0,1,0,26.542,55,3.542,3.542,0,0,0,23,58.542Zm4.723,0a1.181,1.181,0,1,1-1.181-1.181A1.181,1.181,0,0,1,27.723,58.542Z",
    transform: "translate(4.157 9.94)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9056",
    "data-name": "Path 9056",
    d: "M69.182,10.323a4.526,4.526,0,0,0-6.392,0L29.527,43.587a1.179,1.179,0,0,0-.323.6l-1.181,5.9a1.181,1.181,0,0,0,1.158,1.412,1.215,1.215,0,0,0,.232-.024l5.9-1.181a1.184,1.184,0,0,0,.6-.323L69.182,16.716a4.519,4.519,0,0,0,0-6.393Zm-1.67,4.723L34.5,48.057l-3.816.763L31.449,45l33.01-33.011a2.159,2.159,0,0,1,3.053,3.053Z",
    transform: "translate(5.06 1.627)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpad);
export default __webpack_public_path__ + "static/media/Ipad.5d132992f5d2ca2c5dad8598e10b2f32.svg";
export { ForwardRef as ReactComponent };